//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import Droppable from "../../Droppable"
import formulaBuilderTypes from "../formulaBuilderTypes"

export default function RenderFormulaConnector({
  connector,
  formulaId,
  overConnectorId,
}) {
  const idValue = `${formulaBuilderTypes.droppableIds.connector}${formulaId}`
  const operator = formulaBuilderTypes.operators.find(
    (operator) => operator.name === connector
  )
  let display = "??"

  if (operator) {
    if (operator.iconName) {
      display = <span className="material-icons">{operator.iconName}</span>
    } else {
      display = operator.display
    }
  }

  return (
    <div
      className={`${myStyles.formulaRenderOperators} ${
        overConnectorId === idValue ? myStyles.activeOperator : ""
      }`}
    >
      <Droppable id={idValue} className={myStyles.formulaRenderConnector}>
        {display}
      </Droppable>
    </div>
  )
}
